import React, { ChangeEvent } from 'react';
import { useField } from 'formik';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { P } from '@components/shared/Typography';
import { DropdownOptions } from '@contracts';
import ReactSelect from '../ReactSelect';

interface Props {
  id: string;
  label?: string;
  value?: string;
  description?: string;
  onChange?: ((e: ChangeEvent<any>) => void) | undefined;
  options: DropdownOptions[];
}

const SelectDropdown: React.FC<Props> = ({ id, label, value, description, onChange, options }) => {
  const [, meta] = useField({ value, name: id, onChange });
  const hasError = meta.error && meta.touched;

  const colourStyles = {
    control: (styles: any) => ({
      ...styles,
      backgroundColor: Colors.cream,
      marginTop: '10px',
      cursor: 'pointer',
      border: hasError ? `1px solid ${Colors.red}` : `1px solid ${Colors.gold}`,
      padding: 0,
      fontFamily: 'BrownStd',
      fontSize: '15px',
      lineHeight: '24px',
      background: Colors.cream,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '2px',
      height: '50px',
      '&:hover': {
        border: `1px solid ${Colors.gold}`
      }
    }),
    menuPortal: (styles: any) => ({ ...styles, zIndex: 9999 }),
    option: (styles: any, { isDisabled, isFocused }: any) => ({
      ...styles,
      backgroundColor: isFocused ? Colors.forestGreen : Colors.cream,
      color: isFocused ? Colors.cream : Colors.forestGreen,
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      fontFamily: 'BrownStd',
      fontSize: '15px',
      lineHeight: '24px'
    })
  };

  return (
    <InputWrapper>
      {label && <PStyled error={hasError ? 1 : 0}>{label}</PStyled>}
      {description && <Description>{description}</Description>}
      <ReactSelect
        id={id}
        options={options}
        styles={colourStyles}
        onChange={onChange}
        value={options.filter((option) => option.value === value)}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
      />
      {/* {meta.error && meta.touched && <FormFieldError message={meta.error} style={{ marginTop: 10 }} />} */}
    </InputWrapper>
  );
};

export default SelectDropdown;

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 30px;
`;

interface PStyledProps {
  error?: number;
}

const PStyled = styled(P)<PStyledProps>`
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  margin-top: 0;
  color: ${(props) => (props.error ? Colors.red : 'inherit')};

  &:first-child {
    margin-top: 0;
  }
`;

const Description = styled(PStyled)`
  font-weight: 400;
`;
